package com.kaihuoy.auth

import androidx.compose.runtime.*
import androidx.compose.runtime.rememberCoroutineScope
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.css.*
import com.kaihuoy.web.FirebaseService
import com.kaihuoy.components.common.*

private fun currentTimeMs(): Double = js("Date.now()").unsafeCast<Double>()
private fun checkRecaptcha(): kotlin.js.Promise<Boolean> = js("window.checkRecaptcha()").unsafeCast<kotlin.js.Promise<Boolean>>()


@Composable
fun LoginScreen(onLoginSuccess: () -> Unit) {
    var email by remember { mutableStateOf("") }
    var password by remember { mutableStateOf("") }
    var honeypot by remember { mutableStateOf("") }
    var errorMessage by remember { mutableStateOf<String?>(null) }
    val loadedAt: Double = remember { currentTimeMs() }
    val auth = FirebaseService.auth
    val scope = rememberCoroutineScope()

    Div(attrs = {
        style {
            display(DisplayStyle.Flex); flexDirection(FlexDirection.Column)
            alignItems(AlignItems.Center); justifyContent(JustifyContent.Center)
            width(100.percent); minHeight(100.vh); padding(20.px)
            backgroundColor(KaihuTheme.Background)
        }
    }) {
        Div(attrs = {
            style {
                backgroundColor(KaihuTheme.Surface); padding(40.px); borderRadius(20.px)
                width(100.percent); maxWidth(400.px)
                property("box-shadow", KaihuTheme.ShadowLg)
                property("border", "1px solid ${KaihuTheme.Border}")
                display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); alignItems(AlignItems.Center)
            }
        }) {
            H1(attrs = { style { margin(0.px, 0.px, 8.px, 0.px); color(KaihuTheme.PrimaryTeal); fontWeight("800") } }) { Text("KaihuOY") }
            H2(attrs = { style { margin(0.px, 0.px, 32.px, 0.px); color(KaihuTheme.TextSecondary); fontSize(1.2.em); fontWeight("500") } }) { Text("Tervetuloa takaisin") }

            Input(type = InputType.Email, attrs = {
                value(email); onInput { email = it.value }
                attr("placeholder", "Sähköpostiosoite")
                style {
                    width(100.percent); padding(14.px); marginBottom(12.px); borderRadius(12.px)
                    border(1.px, LineStyle.Solid, KaihuTheme.Border); outline("none"); boxSizing("border-box")
                    backgroundColor(KaihuTheme.Background); color(KaihuTheme.TextPrimary); fontSize(1.em)
                }
            })

            Input(type = InputType.Password, attrs = {
                value(password); onInput { password = it.value }
                attr("placeholder", "Salasana")
                style {
                    width(100.percent); padding(14.px); marginBottom(12.px); borderRadius(12.px)
                    border(1.px, LineStyle.Solid, KaihuTheme.Border); outline("none"); boxSizing("border-box")
                    backgroundColor(KaihuTheme.Background); color(KaihuTheme.TextPrimary); fontSize(1.em)
                }
            })

            // Hunajakenttä — piilotettu ihmisiltä, botit täyttävät tämän
            Input(type = InputType.Text, attrs = {
                value(honeypot)
                onInput { honeypot = it.value }
                attr("autocomplete", "off")
                attr("tabindex", "-1")
                style {
                    property("position", "absolute")
                    property("left", "-9999px")
                    property("opacity", "0")
                    property("height", "0")
                    property("width", "0")
                }
            })

            errorMessage?.let {
                P(attrs = { style { color(KaihuTheme.Danger); fontSize(0.9.em); marginBottom(16.px); textAlign("center") } }) { Text(it) }
            }

            StyledButton(
                text = "Kirjaudu",
                onClick = {
                    scope.launch {
                        // Botti täytti piilotetun kentän
                        if (honeypot.isNotEmpty()) return@launch
                        if (currentTimeMs() - loadedAt < 2000.0) return@launch
                        try {
                            checkRecaptcha() // käynnistetään taustalla, ei odoteta
                            auth.signInWithEmailAndPassword(email, password)
                            onLoginSuccess()
                        } catch (exception: Throwable) {
                            errorMessage = "Sähköposti tai salasana ei täsmää — yritä uudelleen."
                        }
                    }
                }
            )

        P(attrs = { style { fontSize(0.75.em); color(KaihuTheme.TextLight); textAlign("center"); marginTop(16.px) } }) {
            Text("Tämä sivusto on suojattu reCAPTCHA:lla (")
            A(href = "https://policies.google.com/privacy") { Text("tietosuoja") }
            Text(" / ")
            A(href = "https://policies.google.com/terms") { Text("ehdot") }
            Text(")")
        }
        }
    }
}
